module.exports = __webpack_public_path__ + "static/media/fb-create-adaccount-1-en.c8c37ecf.png";